import script from "./GameEntry.vue?vue&type=script&setup=true&lang=js"
export * from "./GameEntry.vue?vue&type=script&setup=true&lang=js"

import "./GameEntry.vue?vue&type=style&index=0&id=5fa31417&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5fa31417"]])

export default __exports__